import React from "react";
import {
  TIME_FIELD_LABEL,
  TIME_SELECT_CLASS,
} from "./staffScheduleModalTheme";

const HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1));
const MINUTES = ["00", "15", "30", "45"];
const PERIODS = ["AM", "PM"];

const selectWrap = (narrow = false) =>
  narrow
    ? "relative w-[4.75rem] shrink-0"
    : "relative flex-1 min-w-[3.25rem]";

const chevronCls =
  "pointer-events-none absolute inset-y-0 right-2 flex items-center text-indigo-400 text-[10px]";

const TimePickerField = ({
  label,
  hour12,
  minute,
  period,
  onChange,
  disabled = false,
}) => (
  <div className="rounded-lg border border-indigo-200 bg-white p-3 shadow-sm">
    <label className={TIME_FIELD_LABEL}>{label}</label>
    <div className="mt-2 flex items-center gap-2">
      <div className={selectWrap(false)}>
        <select
          value={hour12}
          disabled={disabled}
          aria-label={`${label} hour`}
          onChange={(e) => onChange({ hour12: e.target.value, minute, period })}
          className={`${TIME_SELECT_CLASS} w-full pr-7`}
        >
          {HOURS.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
        <span className={chevronCls} aria-hidden>
          ▾
        </span>
      </div>

      <span className="text-base font-bold text-indigo-300 leading-none select-none">
        :
      </span>

      <div className={selectWrap(false)}>
        <select
          value={minute}
          disabled={disabled}
          aria-label={`${label} minute`}
          onChange={(e) => onChange({ hour12, minute: e.target.value, period })}
          className={`${TIME_SELECT_CLASS} w-full pr-7`}
        >
          {MINUTES.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
        <span className={chevronCls} aria-hidden>
          ▾
        </span>
      </div>

      <div className={selectWrap(true)}>
        <select
          value={period}
          disabled={disabled}
          aria-label={`${label} AM or PM`}
          onChange={(e) => onChange({ hour12, minute, period: e.target.value })}
          className={`${TIME_SELECT_CLASS} w-full pr-7 text-indigo-700`}
        >
          {PERIODS.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
        <span className={chevronCls} aria-hidden>
          ▾
        </span>
      </div>
    </div>
  </div>
);

export default TimePickerField;
